import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import PersonalInfo from "./PersonalInfo";
import { useSearchParams } from "react-router-dom";
import ChangePasswordPage from "../../../authentication/ChangePassword";

export default function PersonalSupervisorInfoPage() {
  const LocalBasePath = "page.student.dashboard.personalInfo";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [
    {
      name: t("info"),
      cypressSelector: "info",
      content: <PersonalInfo />,
    },
    {
      name: t("changePassword"),
      cypressSelector: "changePassword",
      content: <ChangePasswordPage />,
    },
  ];
  return (
    <div className="w-full flex flex-col px-8">
      <div>
        <h1 className=" text-2xl font-semibold text-gray-900 mt-2 mb-4">
          {t("personalProfile")}
        </h1>
      </div>
      <TabsComponent defaultTab={+(searchParams.get("tab") ?? 0)} tabs={tabs} />
    </div>
  );
}
